export default __webpack_public_path__ + "static/media/about-circle-bg.7af82904.png";